module.exports = __webpack_public_path__ + "img/404-01.fed1a005.png";